<template>
  <div id="app">
    <div class="top-header">
      <TopHeader v-if="showTopBar"/>
    </div>
    <!-- 主体区域：左侧标签栏 + 路由页面 [Claude Code] -->
    <div class="app-body">
      <LeftTabs v-if="showTopBar" />
      <div class="app-view">
        <router-view :key="$route.path"/>
      </div>
    </div>
    <FootPage v-if="showTopBar"/>
    <!-- <submitJira/> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Bus from '@/assets/js/vueBus.js'
import { loadMediaJs } from '@/assets/js/loadSource.js'
import BillingInstance from '@/assets/js/billing'
import previewInstance from '@/assets/js/preview'
import TopHeader from '@/components/common/topHeader.vue'
import FootPage from '@/components/common/footPage.vue'
import LeftTabs from '@/components/common/leftTabs.vue'
// import submitJira from './components/common/submitJira.vue'
export default {
  name: 'App',
  components: {
    TopHeader,
    FootPage,
    LeftTabs
    // submitJira
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState({
      pageRequestWs: state => state.websocket.pageRequestWs,
      pageSerBusRequestWs: state => state.websocket.pageSerBusRequestWs,
      operateObject: 'operateObject',
      userInfo: 'userInfo',
      tvuUserInfo: 'tvuUserInfo',
      initConfig: 'initConfig',
      defaultAdminConfig: 'defaultAdminConfig'
    }),
    serverName () {
      return this.initConfig.currentEnvAppName || 'mediahub'
    },
    showTopBar () {
      return !window.location.href.includes('from=noc') && !window.location.href.includes('from=workFlow') && !window.location.href.includes('from=art')
    },
    isUpdateUserAndPage () { // 多个tab或者服务切换了账号，可以及时更新
      if (this.userInfo.id && this.tvuUserInfo.id && (this.userInfo.id != this.tvuUserInfo.id)) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    isUpdateUserAndPage (value) {
      // 如果切换了用户，刷新页面
      if (value) {
        window.location.reload()
      }
    },
    'userInfo.id': {
      handler (value) {
        if (value) {
          // console.log('userInfo.id', value)
          if (!this.pageSerBusRequestWs && !window.location.href.includes('manager')) {
            this.$createWebsocket.pageSerBusRequestFn('', '', this.pageSerBusRequestCallback)
          }
          if (!this.pageRequestWs) {
            this.$createWebsocket.pageRequestFn()
          }
          previewInstance.loadWebRtc()
          if (!this.initConfig.disableBilling) {
            BillingInstance.initBilling(this.initConfig)
          }
          this.initMediaJs()
        }
      },
      immediate: true
    },
    'adminInfo.ingesting': {
      handler (val) {
        if (val == '0' && this.$route.name == 'calendar') {
          this.$router.push({
            name: 'mediaHub'
          })
        }
      },
      immediate: true
    }
  },
  created () {
    window.addEventListener('beforeunload', this.closeWebSocket)
  },
  methods: {
    pageSerBusRequestCallback (data, module, result) {
      Bus.$emit('websocketMessage', data, module, result)
      if (module == 'MHNotify' && result.moduleTag == 'permissionChange') {
        // 更新permission
        if (data.groupId == this.operateObject?.rootGroup?.groupId) {
          const defaultConfig = this.defaultAdminConfig
          this.commitAdminPermission(defaultConfig, data)
        }
      }
    },
    commitAdminPermission (defaultConfig, data = {}) {
      let newConfig = {}
      Object.entries(data).forEach(([key, value]) => {
        if (key != 'groupId') {
          newConfig[key] = value || defaultConfig[key]
        }
      })
      const config = {
        ...defaultConfig,
        ...newConfig
      }
      this.$store.commit('setAdminInfo', {
        ...config,
        loaded: true
      })
    },
    initMediaJs () {
      loadMediaJs(this.initConfig, () => {
        try {
          const loginUrl = `${window.location.protocol}//${this.initConfig.newuserserviceUrl}/?url=${this.initConfig.mediaHubCallBackUrl}&serviceName=${this.initConfig.serviceName}`
          const mediaInfo = {
            loginUrl,
            platform: 'MediaHub',
            page: 'MediaHub',
            appName: this.initConfig.serviceName,
            // supportPlatform: this.initConfig.mediaTypes,
            mxServiceUrl: this.initConfig.mxServiceUrl,
            passThrough: this.initConfig.passthrough || null,
            currentUserId: this.userInfo.id,
            userInfo: this.userInfo,
            defaultBoxType: 1,
            shareToggle: true
          }
          if (this.$TVUMx && this.$TVUMx.useLatestStore) {
            Object.assign(this.$TVUMx, JSON.parse(JSON.stringify(mediaInfo)))
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    closeWebSocket () {
      if (this.pageSerBusRequestWs) {
        this.$createWebsocket.pageSerBusRequestFn('off')
      }
      if (this.pageRequestWs) {
        this.$createWebsocket.pageRequestFn('off')
      }
      // // 取消默认行为
      // event.preventDefault()
      // // Chrome 需要设置返回值
      // event.returnValue = 'Your changes may not be saved'
    }
  },
  beforeDestroy () {
    try {
      this.closeWebSocket()
      window.removeEventListener('beforeunload', this.closeWebSocket)
    } catch (error) {
      console.log(error)
    }
  },
  beforeRouteEnter (to, from, next) {
    next()
  }
}
</script>

<style lang="less">
#myCustomTrigger {
  position: fixed;
  top: 100px;
  left: 100px;
  z-index: 100;
}
#queryTrigger {
  left: 200px;
  position: fixed;
  top: 100px;
  z-index: 100;
}
// 主体区域：flex 行排列，左侧标签栏 + 内容区 [Claude Code]
.app-body {
  display: flex;
  flex-direction: row;
}
// 路由内容区，填充剩余宽度 [Claude Code]
.app-view {
  flex: 1;
  min-width: 0;
}
#app {
  position: relative;
  height: 100%;
  background-color: #141414;
  text-align: center;
  .foot-box {
    position: absolute;
    z-index: 20;
    bottom: 9px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;

    span,
    a {
      vertical-align: middle;
      margin-right: 12px;
      color: #9a9a9a;
    }

    a {
      cursor: pointer;
    }

    a:hover {
      text-decoration: underline;
    }

    img {
      width: 107px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>
